<div class="sidebar-wrapper" [ngClass]="activeModule === moduleType.AnalysisDashboard ? 'disable-hover' : ''">
    <div class="sidebar-links">
        <project-valuation-navigation *ngIf="activeModule === moduleType.ProjectValuation">
        </project-valuation-navigation>
        <comparables-navigation *ngIf="activeModule === moduleType.Comparables"></comparables-navigation>
        <admin-navigation *ngIf="activeModule === moduleType.AppSettings"></admin-navigation>
        <project-main-navigation *ngIf="activeModule === moduleType.ProjectMain"></project-main-navigation>
    </div>
</div>
